import { render } from "./LocationDetail.vue?vue&type=template&id=09d42c12&ts=true"
import script from "./LocationDetail.vue?vue&type=script&lang=ts"
export * from "./LocationDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__